/**
 * DV360 Floodlight tags (Blacksmith SF c/o Client Direct — App LP pixel).
 * Loaded on production and staging (app.blacksmith.sh / staging.blacksmith.sh).
 */

import { isProductionOrStaging } from "./environment";

export const DV360_FLOODLIGHT_CONFIG_ID = "DC-16638578";

/** Activity / conversion send_to for App landing page (app.blacksmith.sh /). */
export const DV360_APP_LP_SEND_TO = "DC-16638578/invmedia/black003+standard";

const ALLOWED_DV360_SITE_URLS = new Set([
  "https://app.blacksmith.sh",
  "https://staging.blacksmith.sh",
]);

export function shouldLoadDv360Floodlight(): boolean {
  return (
    isProductionOrStaging() &&
    ALLOWED_DV360_SITE_URLS.has(process.env.NEXT_PUBLIC_SITE_URL ?? "")
  );
}
